import UpgradePlanSection from './UpgradePlanSection';

export default UpgradePlanSection;